import React, {useState} from 'react';
import {useFormik} from 'formik';
import * as yup from 'yup';
import {regex} from '@capsovision/capso_utils';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import Typography from '@mui/material/Typography';


export default function SetNewPassword({handleSubmit, handleBack}) {

	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	}

	const pwVisibleToggle = (
		<InputAdornment position="end">
			<IconButton
				aria-label="toggle password visibility"
				onClick={handleClickShowPassword}
			>
				{showPassword ? <VisibilityOff /> : <Visibility />}
			</IconButton>
		</InputAdornment>
	);

	const formik = useFormik({
		initialValues: {
			code: '',
			newPassword: '',
			rptPassword: ''
		},
		validationSchema: yup.object({
			code: yup.string().required().length(6, 'Verification code has 6 digits'),
			newPassword: yup.string().required('New password is required').matches(regex.password, 'Your password must contain at least eight characters, at least one number and both lower and uppercase letters'),
			rptPassword: yup.string().oneOf([yup.ref('newPassword')], 'Passwords must match')
		}),
		onSubmit: async (values) => {
			await handleSubmit(values)
		},
	});

	return (
		<Box sx={{
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
		}}>
			<Box component="form" onSubmit={(e) => {
				e.preventDefault();
				formik.handleSubmit();
			}} sx={{
				mt: 1,
				maxWidth: "sm"
			}}>
				<Typography variant="subtitle2" gutterBottom component="div">
					Please type in the code you received below.
				</Typography>
				<TextField
					margin="normal"
					required
					fullWidth
					id="code"
					label="Code"
					name="code"
					autoFocus
					value={formik.values.code}
					onChange={formik.handleChange}
					error={formik.touched.code && Boolean(formik.errors.code)}
					helperText={formik.touched.code && formik.errors.code}
				/>
				<TextField
					margin="normal"
					required
					fullWidth
					name="newPassword"
					label="New Password"
					type={showPassword ? 'text' : 'password'}
					id="newPassword"
					autoComplete="new-password"
					value={formik.values.newPassword}
					onChange={formik.handleChange}
					error={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
					helperText={formik.touched.newPassword && formik.errors.newPassword}
					InputProps={{
						endAdornment: pwVisibleToggle
					}}
				/>
				<TextField
					margin="normal"
					required
					fullWidth
					name="rptPassword"
					label="Repeat Password"
					type={showPassword ? 'text' : 'password'}
					id="rptPassword"
					autoComplete="new-password"
					value={formik.values.rptPassword}
					onChange={formik.handleChange}
					error={formik.touched.rptPassword && Boolean(formik.errors.rptPassword)}
					helperText={formik.touched.rptPassword && formik.errors.rptPassword}
					InputProps={{
						endAdornment: pwVisibleToggle
					}}
				/>
				<Button
					type="submit"
					fullWidth
					variant="contained"
					sx={{ mt: 3, mb: 2 }}
				>
					Submit
				</Button>
				<Button
					fullWidth
					variant="contained"
					color="warning"
					onClick={handleBack}
				>
					Back
				</Button>
			</Box>
		</Box>
	)
}